<template>
<div>
    <template >
    <div :id="this.selectedorderID">
    <div  class="card" :class="[orderOBJ.status == 'בוטלה' ? 'canceledOrder' : 'card',  orderOBJ.status == 'מוכנה' ? 'orderReady' : 'card', orderOBJ.status == 'נמסרה' ? 'confirmed' : 'card',]"  >
        <div class="head">
            <span class="name">{{ orderOBJ.fullname  }}</span>
            <span class="orderNumber" >#{{ orderOBJ.orderNumber  }}</span>
            <!-- <span class="status acceptBadge" v-show="order.Data.status == 'התקבלה'">{{ order.Data.status  }} </span>
            <span class="status readyBadge" v-show="order.Data.status == 'מוכנה'">{{ order.Data.status  }} </span>
            <span class="status shippedBadge" v-show="order.Data.status == 'נמסרה'">{{ order.Data.status  }} </span>
            <span class="status canceledBadge" v-show="order.Data.status == 'בוטלה'">{{ order.Data.status  }} </span>
            <span class="status inprogressBadge" v-show="order.Data.status == 'שלב הכנה'">{{ order.Data.status  }} </span> -->
            <span class="status" >
                <select  v-model="orderOBJ.status"
                 @change="updateStatus()"
                   :class="[orderOBJ.status == 'בוטלה' ? 'canceledBadge' : 'select',
                     orderOBJ.status == 'מוכנה' ? 'readyBadge' : 'select',
                     orderOBJ.status == 'נמסרה' ? 'shippedBadge' : 'select',
                     orderOBJ.status == 'התקבלה' ? 'acceptBadge' : 'select', ]"  >
                        <option value="מוכנה">מוכנה</option>
                        <option value="שלב הכנה">שלב הכנה</option>
                        <option value="בוטלה">בוטלה</option>
                        <option value="התקבלה">התקבלה</option>
                        <option value="נמסרה">נמסרה</option>
                </select>
            </span>
            
        </div>
        <div class="head">
            <span class="day">יום {{ orderOBJ.dayOrder }}</span>
            <span class="time">{{ orderOBJ.timeOrder }}</span>
            <span class="date">
                <!-- <input type="date" v-model="order.Data.dateOrder" disabled> -->
                {{ orderOBJ.dateOrder }}
            </span>
        </div>
        <div class="orderCart">
            <!-- <span class="title">פרטי הזמנה</span> -->
            <span class="title" @click="printDiv(order.ID)">הדפס</span>

            <div class="item" v-for="item in orderOBJ.cart">
                <span class="selectedquantity">x{{ item.selectedCount }}</span>
                <span class="itemName">{{ item.Data.Name }}</span>
                <span class="subTotal">₪{{ item.Data.Price * item.selectedCount}}</span>
                
            </div>
            <div class="note" v-if="orderOBJ.note.length > 0">
                <span>{{ orderOBJ.note }}</span>
            </div>
            <div class="images">
                <div v-for="(img,index) in orderOBJ.orderImg"  :key="index">
                    <img :src="img" alt=""  >
                </div>  
            </div>
            
        </div>
        <div class="flex"></div>
        <div class="footerCard">
            <!-- <span class="totalTitle">
                סה"כ לתשלום 
            </span>
            <span class="totalAmount">
                ₪{{ order.Data.totalOrderPrice }}
            </span> -->

            <div class="col3">
                <span class="totalTitle">
                סטטוס גבייה 
                </span>
                <span class="totalAmount" :class="[orderOBJ.paidStatus == 'שולם' ? 'paid' : 'totalAmount' , orderOBJ.paidStatus == 'לא שולם' ? 'unPaid' : 'totalAmount'  ]">
                    
                    {{ orderOBJ.paidStatus }}
                </span>
            </div>
            <!-- <div class="col3">
                <span class="totalTitle">
                שיטת תשלום
                </span>
                <span class="totalAmount">
                    {{ order.Data.payment }}
                </span>
            </div> -->
            <div class="col3">
                <span class="totalTitle">
                סה"כ לתשלום 
                </span>
                <span class="totalAmount">
                    ₪{{ orderOBJ.totalOrderPrice -  orderOBJ.discount}}
                </span>
            </div>
        </div>
    </div>
</div>
</template>
</div>
</template>
<script>
import { db } from '../firebase';
import firebase from "firebase/app";
import moment from 'moment';
import "firebase/storage"
import he from 'moment/locale/he'
import order from '../components/Order.vue';
import orderCard from '../components/orderCard.vue';
export default {
  name: 'printOrder',
  components:{
    order,orderCard
  },
  data () {
    return {
        selectedorderID: this.$route.params.id,
        txtSearch:''
    }
  },
  created(){
    let vm = this;
        console.log(this.$route.params.id);
        vm.loadSingleOrder();
  },
  computed: {
      filteredOrders() {
        let vm = this;
        if (vm.txtSearch.length > 0) {
          let orders = [];
          for (let i = 0; i < vm.orders.length; i++) {
            let t = vm.orders[i];
            let found = false;
            if (t.Data.fullname.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
              found = true;
            }
            if (t.Data.phoneNumber.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
              found = true;
            }
            // if (t.Time.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
            //   found = true;
            // }
            if (found) {
              orders.push(t);
            }
          }
          return orders;
        } else {
          return vm.orders;
        }
      }
    },
  methods:{
    loadSingleOrder(){
            let vm = this;
            db.collection("orders").doc(vm.selectedorderID).get()
            .then((order) =>{
                vm.isLoading = false;
                let orderData = order.data();
                let fullname = orderData.fullname;
                let orderNumber = orderData.orderNumber;
                let dayOrder = orderData.dayOrder;
                let dateOrder = orderData.dateOrder;
                let createdDate = orderData.createdDate;
                let phoneNumber = orderData.phoneNumber;
                let status = orderData.status;
                let timeOrder = orderData.timeOrder;
                let totalOrderPrice = orderData.totalOrderPrice;
                let orderImg = orderData.orderImg;
                let cart = orderData.Cart;
                let paidStatus = orderData.paidStatus;
                let discount = orderData.discount;
                // console.log(fullname);
                console.log(orderData);
                vm.orderOBJ = {
                    fullname : orderData.fullname,
                    orderNumber : orderData.orderNumber,
                    dayOrder : orderData.dayOrder,
                    dateOrder : orderData.dateOrder,
                    createdDate : orderData.createdDate,
                    phoneNumber : orderData.phoneNumber,
                    status : orderData.status,
                    timeOrder : orderData.timeOrder,
                    totalOrderPrice : orderData.totalOrderPrice,
                    orderImg : orderData.orderImg,
                    cart : orderData.cart,
                    paidStatus : orderData.paidStatus,
                    discount : orderData.discount,
                }
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        },
  }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/pages/printOrder.vue